<template>
  <b-card>
    <div class="d-flex">
      <h4 class="mb-0">Setting</h4>
    </div>

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <b-col
            cols="12"
            v-if="settingData.icon_image_path"
            style="text-align: center"
          >
            <hr />
            <img
              style="width: 30%"
              :src="getImgPath(settingData.icon_image_path)"
            />
          </b-col>
          <b-col cols="12">
            <hr />
          </b-col>
          <b-col md="12">
            <b-form-group label="Logo" label-cols-md="3">
              <el-upload
                class="avatar-uploader"
                list-type="picture-card"
                ref="upload"
                :action="uploadUrl"
                :headers="headerObj"
                name="image_file"
                :file-list="fileList"
                multiple
                :limit="1"
                :data="settingData"
                :on-change="onChange"
                :on-remove="toggleUpload"
                :before-remove="beforeRemove"
                :auto-upload="false"
                :class="{ hideUpload: !showUpload }"
              >
                <img
                  v-if="settingData.icon_image_path && false"
                  :src="getImgPath(settingData.icon_image_path)"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Meta Title" label-for="meta_title" label-cols-md="3">
              <b-form-input id="meta_title" v-model="settingData.meta_title" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Meta Description" label-for="meta_description" label-cols-md="3">
              <b-form-input id="meta_description" v-model="settingData.meta_description" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Meta Keywords" label-for="meta_keywords" label-cols-md="3">
              <b-form-input id="meta_keywords" v-model="settingData.meta_keywords" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Address" label-for="address" label-cols-md="3">
              <b-form-input id="address" v-model="settingData.address" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Phone" label-for="phone" label-cols-md="3">
              <b-form-input id="phone" v-model="settingData.phone" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Whatapps" label-for="phone" label-cols-md="3">
              <b-form-input id="phone" v-model="settingData.whatsapp" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Email" label-for="email" label-cols-md="3">
              <b-form-input id="email" v-model="settingData.email" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Website" label-for="website" label-cols-md="3">
              <b-form-input id="website" v-model="settingData.website" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group
              label="Working Hour"
              label-for="working_hour"
              label-cols-md="3"
            >
              <b-form-input
                id="working_hour"
                v-model="settingData.working_hour"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group
              label="Facebook Link"
              label-for="facebook_link"
              label-cols-md="3"
            >
              <b-form-input
                id="facebook_link"
                v-model="settingData.facebook_link"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="IG Link" label-for="ig_link" label-cols-md="3">
              <b-form-input id="ig_link" v-model="settingData.ig_link" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Twitter Link" label-for="twitter_link" label-cols-md="3">
              <b-form-input id="twitter_link" v-model="settingData.twitter_link" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Tripadvisor Link" label-for="tripadvisor_link" label-cols-md="3">
              <b-form-input id="tripadvisor_link" v-model="settingData.tripadvisor_link" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Openrice Link" label-for="openrice_link" label-cols-md="3">
              <b-form-input id="openrice_link" v-model="settingData.openrice_link" />
            </b-form-group>
          </b-col>
          <!-- <b-col cols="12" md="12">
            <b-form-group label="About Text" label-for="about_text" label-cols-md="3">
              <b-form-textarea
                id="about_text"
                v-model="settingData.about_text"
                autofocus
                trim
                rows="10"
                placeholder="About Text"
              />
            </b-form-group>
          </b-col> -->
          <b-col cols="12" md="12">
            <b-form-group label="Footer Text" label-for="footer_text" label-cols-md="3">
              <b-form-textarea
                id="footer_text"
                v-model="settingData.footer_text"
                autofocus
                trim
                rows="3"
                placeholder="Footer Text"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group
              label="Google Map"
              label-for="google_map"
              label-cols-md="3"
            >
              <b-form-input id="google_map" v-model="settingData.google_map_url" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group
              label="Google Map for iframe"
              label-for="google_map"
              label-cols-md="3"
            >
              <b-form-input id="google_map" v-model="settingData.google_map" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="12" v-if="settingData.google_map">
            <b-form-group
              label="Google Map View"
              label-for="google_map"
              label-cols-md="3"
            >
              <iframe
                :src="settingData.google_map"
                width="600"
                height="450"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Form Actions -->

        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
          >
            Save
          </b-button>
        </div>
      </b-form>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BCard,
  BCardBody,
  BButton,
  BFormCheckbox,
  BFormDatepicker,
  BInputGroupAppend,
  BInputGroup,
  BFormInvalidFeedback,
  BFormTextarea,
  BOverlay,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import settingStoreModule from "./settingStoreModule";
import { ref, onUnmounted } from "@vue/composition-api";

export default {
  directives: {
    Ripple,
  },
  components: {
    BFormTextarea,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BFormCheckbox,
    BFormDatepicker,
    BInputGroupAppend,
    BInputGroup,
    BFormInvalidFeedback,
    BOverlay,
  },
  methods: {
    getImgPath(path) {
      return process.env.VUE_APP_IMAGE_URL + path;
    },
    toggleUpload() {
      this.showUpload = !this.showUpload;
      this.settingData.file = null
    },
    onSubmit() {
      this.$swal({
        title: "Are you sure?",
        showCancelButton: true,
        confirmButtonText: "Save",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData();
          formData.append("file", this.settingData.file);
          formData.append("id", this.settingData.id);
          formData.append("address", this.settingData.address);
          formData.append("whatsapp", this.settingData.whatsapp);
          formData.append("phone", this.settingData.phone);
          formData.append("email", this.settingData.email);
          formData.append("website", this.settingData.website);
          formData.append("working_hour", this.settingData.working_hour);
          formData.append("facebook_link", this.settingData.facebook_link);
          formData.append("ig_link", this.settingData.ig_link);
          formData.append("twitter_link", this.settingData.twitter_link);
          formData.append("tripadvisor_link", this.settingData.tripadvisor_link);
          formData.append("openrice_link", this.settingData.openrice_link);
          formData.append("google_map", this.settingData.google_map);
          formData.append("google_map_url", this.settingData.google_map_url);
          // formData.append("about_text", this.settingData.about_text);
          formData.append("footer_text", this.settingData.footer_text);
          formData.append("meta_title", this.settingData.meta_title);
          formData.append("meta_description", this.settingData.meta_description);
          formData.append("meta_keywords", this.settingData.meta_keywords);
          
          this.loading = true;
          store
            .dispatch("setting/updateIcon", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });

              this.refetchData();
              if (this.settingData.id == 0) {
                // Return to banner list
                this.hide();
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const loading = ref(false);
    const fileList = ref([]);
    const settingData = ref({});
    const SETTING_STORE_MODULE_NAME = "setting";
    const image_base_url = ref("");
    const showUpload = ref(true);
    
    if (!store.hasModule(SETTING_STORE_MODULE_NAME))
      store.registerModule(SETTING_STORE_MODULE_NAME, settingStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SETTING_STORE_MODULE_NAME))
        store.unregisterModule(SETTING_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      store
        .dispatch(SETTING_STORE_MODULE_NAME + "/fetchStore")
        .then((response) => {
          settingData.value = response.data.data;
          image_base_url.value = response.data.image_base_url;
          console.log(response.data.data);
        });
    };

    refetchData();

    const onChange = (file, fileLists) => {
      console.log(file.raw);
      settingData.value.file = file.raw;
      showUpload.value = !showUpload.value;
    };
    
    const beforeRemove = (file) => {
      settingData.value.file = null
    }
    const uploadUrl = ref(
      process.env.VUE_APP_SERVICE_URL + "/store/updateIcon"
    );
    const headerObj = {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    };

    return {
      loading,
      fileList,
      onChange,
      showUpload,
      beforeRemove,
      refetchData,
      settingData,

      // For Image
      uploadUrl,
      headerObj,
    };
  },
};
</script>

<style lang="scss">
</style>